import { Typography } from '@mui/material'
import * as S from './TransfersManagement.styles'
import TransfersManagementTable from '../../components/TransfersManagementTable/TransfersManagementTable'
import TransfersManagementFilters from '../../components/TransfersManagementFilters/TransfersManagementFilters'

const TransfersManagement = () => (
  <S.Wrapper>
    <Typography variant='h5' fontWeight='bold'>Gerenciamento de Transferências</Typography>
    <TransfersManagementFilters />
    <TransfersManagementTable />
  </S.Wrapper>
)

export default TransfersManagement
